<script>
// Card de marca do ecossistema: lançada (link "Acessar") ou em breve (inativo)
export default {
  locales: {
    pt: {
      'Access': 'Acessar',
      'Coming soon': 'Em breve',
    },
    es: {
      'Access': 'Acceder',
      'Coming soon': 'Próximamente',
    },
  },
  props: {
    name: { type: String, default: "" },
    logo: { type: String, default: "" },
    tagline: { type: String, default: "" },
    color: { type: String, default: "#2C00F5" },
    status: { type: String, default: "soon" },
    to: { type: String, default: "" },
    href: { type: String, default: "" },
  },
  computed: {
    launched() {
      return this.status === "launched";
    },
    tag() {
      if (!this.launched) return "div";
      return this.href ? "a" : "router-link";
    },
    attrs() {
      if (!this.launched) return { "aria-disabled": "true" };
      return this.href ? { href: this.href } : { to: this.to };
    },
  },
};
</script>

<template>
  <component :is="tag" v-bind="attrs" class="brand-card" :class="launched ? 'is-launched' : 'is-soon'" :style="{ '--brand': color }">
    <span class="brand-card-bar" aria-hidden="true"></span>
    <span class="brand-card-body">
      <img class="brand-card-logo" :src="logo" :alt="name" />
      <span class="brand-card-tagline">{{ tagline }}</span>
    </span>
    <span class="brand-card-foot">
      <span class="brand-card-badge">{{ launched ? t('Access') : t('Coming soon') }}</span>
      <i v-if="launched" class="bx bx-right-arrow-alt brand-card-arrow" aria-hidden="true"></i>
    </span>
  </component>
</template>
